<template>
  <div>
    <el-dialog
      top="6vh"
      width="460px"
      center
      :visible="orderCheckEditObj.visible"
      @close="HandleCancel()"
    >
      <div slot="title">
        「{{ orderCheckEditObj.appOrder || "-" }}」 查单状态 (
        {{ orderCheckEditObj.id || "-" }}
        )
      </div>
      <el-form>
        <el-form-item label="查单状态">
          <el-select v-model="checkStatus" size="small">
            <template v-for="option in orderCheckOptions">
              <el-option
                :disabled="[1, 3].indexOf(option.value) !== -1"
                :key="option.value"
                :label="option.label"
                :value="option.value"
              >
              </el-option>
            </template>
          </el-select>
        </el-form-item>

        <!-- <el-radio-group v-model="checkStatus">
          <el-radio
            style="padding: 10px; display: block"
            v-for="option in orderCheckOptions"
            :key="option.label"
            :label="Number(option.value)"
            >{{ option.label }}</el-radio
          >
        </el-radio-group> -->
        <el-form-item label="备注">
          <el-input
            type="textarea"
            :autosize="{ minRows: 3, maxRows: 5 }"
            v-model="remark"
          />
        </el-form-item>
      </el-form>
      <div style="text-align: right">
        <el-button size="mini" @click="HandleCancel()"> 取消 </el-button>
        <el-button
          :disabled="[1, 3].indexOf(checkStatus) !== -1"
          :loading="submitLoading"
          size="mini"
          type="success"
          @click="HandleSubmit()"
        >
          保存
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import mainCommon from "@/utils/mainCommon";
import varCommon from "@/utils/varCommon";
import { updateCheckOrder } from "@/api/checkOrder";

export default {
  mixins: [mainCommon],
  props: ["orderCheckEditObj"],
  data() {
    return {
      orderCheckOptions: varCommon.orderCheckOptions,
      checkStatus: null,
      remark: null,
      submitLoading: false,
    };
  },
  watch: {
    orderCheckEditObj(row) {
      if (row.visible) {
        this.checkStatus = this.orderCheckEditObj.checkStatus;
        this.remark = this.orderCheckEditObj.remark;
      }
    },
  },
  methods: {
    HandleCancel() {
      this.$emit("update:order-check-edit-obj", { visible: false });
    },
    HandleSubmit() {
      this.submitLoading = true;
      updateCheckOrder(this.orderCheckEditObj.id, {
        checkStatus: this.checkStatus,
        remark: this.remark,
      })
        .then((res) => {
          this.$notify.success(res.message);
          this.HandleCancel();
          this.$emit("get-list");
        })
        .finally(() => {
          this.submitLoading = false;
        });
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/views/components/dialog/OrderCheckEditDialog.vue